<template>
  <full-container>
    <!--工具条-->
    <div slot="header" class="toolbar">
      <el-form :inline="true" :model="queryParams" size="small" class="search-form">
        <el-form-item>
          <el-radio-group v-model="queryParams.stock" @change="onSearch()">
            <el-radio-button>全部</el-radio-button>
            <el-radio-button label="1">莱尔</el-radio-button>
            <el-radio-button label="2">威能达</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-input v-model="queryParams.keyWord" placeholder="名称关键字" clearable />
        </el-form-item>
        <el-button type="primary" size="small" @click="onSearch()">查询</el-button>
      </el-form>
      <el-button v-action="'/api/Mall/Goods/Submit'" size="small" type="primary" icon="el-icon-plus" @click="$router.push({ path: 'form' })">新增</el-button>
    </div>

    <!--表格-->
    <el-table v-loading="loading" :data="datalist.Items" height="100%">
      <el-table-column label="库存编码" width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <label class="stock">
            {{ $utils.meta.format('branch', row.Stock) }}
          </label>
          {{ row.Code }}
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="商品名称" min-width="200" show-overflow-tooltip />
      <el-table-column prop="Remark" label="备注信息" min-width="100" show-overflow-tooltip />
      <el-table-column label="单价" width="100">
        <template slot-scope="{ row }">
          <label v-if="row.Price != 0" class="text-price text-danger">{{ row.Price }}/{{ row.Unit }}</label>
          <label v-else class="text-info">电询</label>
        </template>
      </el-table-column>
      <el-table-column label="管理" width="100">
        <el-dropdown slot-scope="{ row }">
          <el-tag size="small" :type="row.State ? 'primary' : 'danger'">
            {{ row.State ? '已上架' : '已下架' }}
            <i class="el-icon-arrow-down" />
          </el-tag>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-action="'/api/Mall/Goods/Submit'" @click.native="$router.push({ path: `form/${row.Id}` })">修改</el-dropdown-item>
            <el-dropdown-item v-action="'/api/Mall/Goods/Delete'" @click.native="onDelete(row)">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination slot="footer" background :page-size="queryParams.size" :total="datalist.TotalCount" @current-change="onSearch" />
  </full-container>
</template>



<script>
export default {
  data () {
    return {
      loading: false,
      datalist: {},
      queryParams: {
        index: 1,
        size: 20,
      },
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      this.loading = true
      this.$apis.mall.goods.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //删除
    onDelete (row) {
      this.$confirm("此操作将永久删除数据不可恢复, 是否继续?", `删除${row.Name}`, {
        center: true,
      }).then(() => {
        this.$apis.mall.goods.delete({ id: row.Id }).then(() => {
          this.$message({ message: "已删除", type: "success" })
          this.loadData()
        }).catch((e) => {
          this.$message.error(e || "系统错误")
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.stock {
  display: inline-block;
  text-align: justify;
  text-align-last: justify;
  width: 3em;
}
</style>
